var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval84AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 88 64",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M14 35c0-7.732 6.268-14 14-14h32c7.732 0 14 6.268 14 14s-6.268 14-14 14H28c-7.732 0-14-6.268-14-14Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M60 23H28c-6.627 0-12 5.373-12 12s5.373 12 12 12h32c6.627 0 12-5.373 12-12s-5.373-12-12-12Zm-32-2c-7.732 0-14 6.268-14 14s6.268 14 14 14h32c7.732 0 14-6.268 14-14s-6.268-14-14-14H28Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M49.224 60.83a2.5 2.5 0 0 1-2.488 2.254h-5.471a2.5 2.5 0 0 1-2.488-2.254l-.529-5.33c-.133-1.343 1.02-2.5 2.49-2.5h6.525c1.47 0 2.622 1.157 2.49 2.5l-.53 5.33Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M47.262 62.167c.686 0 1.314-.356 1.62-.919l.223-.408c.247-.453.848-.636 1.342-.41.494.227.694.777.447 1.23l-.222.408C50.026 63.252 48.706 64 47.262 64h-6.524c-1.444 0-2.764-.748-3.41-1.932l-.222-.408c-.247-.453-.047-1.003.447-1.23.494-.226 1.095-.043 1.342.41l.222.408c.307.563.935.919 1.621.919h6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M32.224 60.83a2.5 2.5 0 0 1-2.488 2.254h-5.471a2.5 2.5 0 0 1-2.488-2.254l-.529-5.33c-.133-1.343 1.02-2.5 2.49-2.5h6.525c1.47 0 2.622 1.157 2.49 2.5l-.53 5.33Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M30.262 62.167c.686 0 1.314-.356 1.62-.919l.223-.408c.247-.453.848-.636 1.342-.41.494.227.694.777.447 1.23l-.222.408C33.026 63.252 31.706 64 30.262 64h-6.524c-1.444 0-2.764-.748-3.41-1.932l-.222-.408c-.247-.453-.047-1.003.447-1.23.494-.226 1.095-.043 1.342.41l.222.408c.307.563.935.919 1.621.919h6.524Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.17 40.224a2.5 2.5 0 0 1-2.253-2.488v-5.471a2.5 2.5 0 0 1 2.253-2.488l5.33-.529c1.343-.133 2.5 1.02 2.5 2.49v6.525c0 1.47-1.157 2.622-2.5 2.49l-5.33-.53Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M1.833 38.262c0 .686.356 1.314.919 1.62l.408.223c.453.247.636.848.41 1.342-.227.494-.777.694-1.23.447l-.408-.222C.748 41.026 0 39.706 0 38.262v-6.524c0-1.444.748-2.764 1.932-3.41l.408-.222c.453-.247 1.003-.047 1.23.447.226.494.043 1.095-.41 1.342l-.408.222c-.563.307-.919.935-.919 1.621v6.524Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M84.83 29.776a2.5 2.5 0 0 1 2.253 2.488v5.471a2.5 2.5 0 0 1-2.253 2.488l-5.33.529c-1.343.133-2.5-1.02-2.5-2.49v-6.525c0-1.47 1.157-2.622 2.5-2.49l5.33.53Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M86.167 31.738c0-.686-.356-1.314-.919-1.62l-.408-.223c-.453-.247-.636-.848-.41-1.342.226-.494.777-.694 1.23-.447l.408.222c1.184.646 1.932 1.966 1.932 3.41v6.524c0 1.444-.748 2.764-1.932 3.41l-.408.222c-.453.247-1.004.047-1.23-.447-.226-.494-.043-1.095.41-1.342l.408-.222c.563-.307.919-.935.919-1.621v-6.524Z",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M66.224 60.83a2.5 2.5 0 0 1-2.488 2.254h-5.471a2.5 2.5 0 0 1-2.488-2.254l-.529-5.33c-.133-1.343 1.02-2.5 2.49-2.5h6.525c1.47 0 2.622 1.157 2.49 2.5l-.53 5.33Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M64.262 62.167c.686 0 1.314-.356 1.62-.919l.223-.408c.247-.453.848-.636 1.342-.41.494.227.694.777.447 1.23l-.222.408C67.026 63.252 65.706 64 64.262 64h-6.524c-1.444 0-2.764-.748-3.41-1.932l-.222-.408c-.247-.453-.047-1.003.447-1.23.494-.226 1.095-.043 1.342.41l.222.408c.307.563.935.919 1.621.919h6.524Z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M34.666 13.5a2.5 2.5 0 0 1-2.5 2.5H20.5a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 20.5 1h14.166v12.5ZM52.334 13.5a2.5 2.5 0 0 1-2.5 2.5H38.166a2.5 2.5 0 0 1-2.5-2.5V1h16.666v12.5ZM70 13.5a2.5 2.5 0 0 1-2.5 2.5H55.833a2.5 2.5 0 0 1-2.5-2.5V1H67.5A2.5 2.5 0 0 1 70 3.5v10Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M18 12a1 1 0 0 1-1-1V3.5A3.5 3.5 0 0 1 20.5 0h47A3.5 3.5 0 0 1 71 3.5V11a1 1 0 1 1-2 0V3.5A1.5 1.5 0 0 0 67.5 2h-47A1.5 1.5 0 0 0 19 3.5V11a1 1 0 0 1-1 1Z",
  clipRule: "evenodd"
})));
SvgOval84AError.viewBox = '0 0 88 64';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval84AError);
export default ForwardRef;